import { Component } from '@angular/core';

@Component({
  selector: 'app-console',
  template: `<xplenty-console></xplenty-console>`,
})
export class ConsoleComponent {}
